const ROUTES = {
  UNAUTH: {
    LANDING: '/',
    LOGIN: '/login',
    AUTH: '/auth',
    KIOSK: '/kiosk',
  },
  AUTH: {
    INDEX: '/app',
    PORTFOLIO: '/app/portfolio',
    ORGANIZATION: '/app/organization',
    SITE: '/app/site',
    METER: '/app/meter',
    PROFILE: '/app/profile',
    GRID_DETAILS: '/app/grid-details',
    TERMS: '/app/terms',
    PRIVACY: '/app/privacy',
  },
};

export default ROUTES;
